import React, { useMemo, useState } from "react";

import { type GetOverviewPerformance_me_overviewPage_performanceMetrics as OverviewPageMetric } from "@north-beam/nb-client-side";
import { MetricValue } from "@shared/metric-value";
import { fmtDateInterval } from "@utils/index";

import { MetricBarChart } from "./metric-bar-chart";
import { MetricSelect } from "./metric-select";

export const MetricGroupBox = ({
  metrics,
  groupName,
  isLoading,
}: {
  metrics: OverviewPageMetric[];
  groupName: string;
  isLoading: boolean;
}) => {
  const [selectedMetricIndex, setSelectedMetricIndex] = useState<number>(0);
  const selectedMetric = useMemo(
    () => metrics[selectedMetricIndex],
    [metrics, selectedMetricIndex],
  );

  const numDates = selectedMetric.timeSeriesPointDateRanges.length;

  const currentValueDisplay = useMemo(() => {
    let prefix = "";
    if (selectedMetric.currentValueDescription) {
      prefix = selectedMetric.currentValueDescription + " ";
    }
    let dateRangeFormatted = "Unknown";
    if (selectedMetric.timeSeriesPointDateRanges.length > 0) {
      const startDate = selectedMetric.timeSeriesPointDateRanges[0].startDate;
      const endDate =
        selectedMetric.timeSeriesPointDateRanges[numDates - 1].endDate;
      dateRangeFormatted = fmtDateInterval({ startDate, endDate });
    }

    return `${prefix}(${dateRangeFormatted})`;
  }, [selectedMetric, numDates]);

  return (
    <div className="border bg-white p-4 rounded-md text-left">
      <div className={isLoading ? "waiting-interstitial" : ""}>
        <div className="flex justify-between pl-3">
          <MetricSelect
            selectedMetric={selectedMetric}
            selectMetricIndex={setSelectedMetricIndex}
            metrics={metrics}
          />
          <div className="text-muted">{groupName}</div>
        </div>
        <div className="p-3">
          <strong className="text-3xl">
            <MetricValue
              as="span"
              precision="approximate"
              value={Number(selectedMetric.currentValue)}
              format={selectedMetric.format}
            />
            &nbsp;
          </strong>
          <small className="text-muted">{currentValueDisplay}</small>
        </div>
        <div className="h-60 pt-3">
          <MetricBarChart selectedMetric={selectedMetric} />
        </div>
      </div>
    </div>
  );
};
